var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowBack)?_c('div',{staticClass:"publicBack iconfont icon-gengduo-copy",style:(_vm.setStyle),on:{"click":_vm.back}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }